// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  text-overflow: ellipsis;
}

body {
  background: #eeeeee;
}

section#container-main {
  height: 100dvh;
}

.ui.checkbox.floating {
  width: 100%;
  margin: 10px 0px;
}

.inline-loader > .loader {
  margin-right: 5px !important;
}

.ui.dropdown:not(.fluid):not(td),
.table.dropdown {
  display: inline-flex !important;
  max-width: 100%;
}

.ui.empty.dropdown {
  cursor: auto !important;
}

.ui.dropdown {
  font-size: inherit;
  max-width: 100%;
}

.ui.dropdown .menu > .item:not(.submenu) {
  max-width: 300px;
  overflow-x: hidden;
}


/*https://github.com/fomantic/Fomantic-UI/issues/3123*/
.ui.dropdown.upward.pointing .item.submenu > .menu {
  bottom: 0 !important;
}

.ui.dropdown.fluid {
  display: flex !important;
}

.popup.trigger:hover {
  cursor: pointer;
}

.ui.popup:not(.table) {
  word-break: break-all;
}

.ui.dropdown.left-icon i.trigger {
  flex-shrink: 0;
}

.ui.dropdown i.trigger {
  align-self: center;
}

.ui.dropdown .menu {
  z-index: 1000;
}

.ui.dropdown .menu .header {
  display: flex;
}

.ui.dropdown:not(.button) > .caption {
  user-select: auto !important;
  overflow: hidden;
  max-width: 100%;
}

td .ui.dropdown > .caption > .icon-caption {
  display: contents;
}


.divided.list .item .description {
  font-size: 90%;
}

/* Layout header start */

.layout.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.layout.header .ui.header {
  max-width: 100%;
  padding: 5px 5px;
  display: inline-flex;
}

.layout.header.icon .ui.header .content {
  /* "overflow: hidden" can't be used because of possible dropdowns */
  width: 90%;
  flex: 1 1;
}

.layout.header i.icons i {
  margin-right: 10px;
}

.layout.header > div {
  margin-bottom: 0px;
}

/* Layout header end */

/* Dialogs start */

.ui.modal.full .layout.header .content {
  /* https://github.com/airdcpp-web/airdcpp-webclient/issues/324 */
  white-space: nowrap;
  overflow: hidden;
}

.ui.modal.full table {
  table-layout: fixed;
}

/* Can't be applied to dropdown cells */
.ui.modal.full td:not(.dropdown) {
  overflow-x: hidden;
}

.ui.modal.full > .content {
  min-height: 350px;
  height: 65vh;
}

.ui.modal > .content {
  overflow-y: auto;
  max-height: 65vh;
}

.ui.modal {
  /* Workaround for https://github.com/Semantic-Org/Semantic-UI/issues/6185 */
  position: fixed !important;
}

/* Ensure that open modals are dimmed when a confirm dialog is displayed */
.ui.dimmer.modals-node {
  z-index: 1002;
}

.ui.dimmer.confirms-node {
  z-index: 1003;
}

.ui.dimmer.confirms-node:not(:empty) {
  opacity: 1;
  display: block;
}

.confirm-dialog {
  z-index: 1004 !important;
}

.confirm-dialog .description,
.input.dialog {
  display: flex !important;
  flex-direction: column !important;
}

.input.dialog.basic,
.confirm-dialog.basic label {
  color: white !important;
}

.input.dialog input,
.confirm-dialog label {
  margin-top: 20px !important;
}

.confirm-dialog .description {
  width: 100% !important;
}

.limiter-config .remove {
  margin-top: 10px;
}

/* Dialogs end */

/* Count label transitions */

.label-transition-exit {
  opacity: 1;
}

.label-transition-exit.label-transition-exit-active {
  opacity: 0.01;
  transition: opacity 1500ms ease-in;
}

/* Count label transitions end */

/* Table dropdown transitions start */
.mainmenu-transition-enter {
  transform: translateX(100%);
}

.mainmenu-transition-enter-active {
  transform: translateX(0);
  transition: transform 200ms ease-in-out;
}

.mainmenu-transition-exit {
  display: none !important;
}

.mainmenu-transition-exit-active {
  display: none !important;
}

.submenu-transition-enter {
  transform: translateX(-100%);
}

.submenu-transition-enter-active {
  transform: translateX(0%);
  transition: transform 200ms ease-in-out;
}

.submenu-transition-exit {
  display: none !important;
}

.submenu-transition-exit-active {
  display: none !important;
}

/* Table dropdown transitions end */

.sidebar .icon-panel .icon.large {
  font-size: 1.3em;
}

td:not(.dropdown),
th {
  overflow: hidden;
}

.notifications-tl h4.notification-title {
  overflow: hidden;
}

.icon-caption > i {
  margin-right: 5px;
}

i.icons .icon:first-child {
  margin-right: 0.25rem;
}

.dupe.queue.full,
.dupe.queue.full span,
.dupe.queue.full a {
  color: #ffa500 !important;
}

.dupe.queue.partial,
.dupe.queue.partial span,
.dupe.queue.partial a {
  color: #ffca68 !important;
}

.dupe.share.full,
.dupe.share.full span,
.dupe.share.full a {
  color: fuchsia !important;
}

.dupe.share.partial,
.dupe.share.partial span,
.dupe.share.partial a {
  color: #ffa2ff !important;
}

.dupe.finished.full,
.dupe.finished.full span,
.dupe.finished.full a {
  color: green !important;
}

.dupe.finished.partial,
.dupe.finished.partial span,
.dupe.finished.partial a {
  color: #79ff79 !important;
}

.dupe.finished.share,
.dupe.finished.share span,
.dupe.finished.share a {
  color: color-mix(in lab, green, fuchsia) !important;
}

.dupe.finished.queue,
.dupe.finished.queue span,
.dupe.finished.queue a {
  color: color-mix(in lab, green, #ffa500) !important;
}

.dupe.share.queue.finished,
.dupe.share.queue.finished span,
.dupe.share.queue.finished a,
.dupe.share.queue,
.dupe.share.queue span,
.dupe.share.queue a {
  color: color-mix(in lab, fuchsia, #ffa500) !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,sDAAsD;AACtD;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mEAAmE;EACnE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB,kBAAkB;;AAElB;EACE,gEAAgE;EAChE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2EAA2E;EAC3E,0BAA0B;AAC5B;;AAEA,0EAA0E;AAC1E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB,4BAA4B;;AAE5B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,gCAAgC;;AAEhC,qCAAqC;AACrC;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;;AAEnC;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;;;;;;EAME,qDAAqD;AACvD","sourcesContent":["* {\r\n  text-overflow: ellipsis;\r\n}\r\n\r\nbody {\r\n  background: #eeeeee;\r\n}\r\n\r\nsection#container-main {\r\n  height: 100dvh;\r\n}\r\n\r\n.ui.checkbox.floating {\r\n  width: 100%;\r\n  margin: 10px 0px;\r\n}\r\n\r\n.inline-loader > .loader {\r\n  margin-right: 5px !important;\r\n}\r\n\r\n.ui.dropdown:not(.fluid):not(td),\r\n.table.dropdown {\r\n  display: inline-flex !important;\r\n  max-width: 100%;\r\n}\r\n\r\n.ui.empty.dropdown {\r\n  cursor: auto !important;\r\n}\r\n\r\n.ui.dropdown {\r\n  font-size: inherit;\r\n  max-width: 100%;\r\n}\r\n\r\n.ui.dropdown .menu > .item:not(.submenu) {\r\n  max-width: 300px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n\r\n/*https://github.com/fomantic/Fomantic-UI/issues/3123*/\r\n.ui.dropdown.upward.pointing .item.submenu > .menu {\r\n  bottom: 0 !important;\r\n}\r\n\r\n.ui.dropdown.fluid {\r\n  display: flex !important;\r\n}\r\n\r\n.popup.trigger:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.ui.popup:not(.table) {\r\n  word-break: break-all;\r\n}\r\n\r\n.ui.dropdown.left-icon i.trigger {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.ui.dropdown i.trigger {\r\n  align-self: center;\r\n}\r\n\r\n.ui.dropdown .menu {\r\n  z-index: 1000;\r\n}\r\n\r\n.ui.dropdown .menu .header {\r\n  display: flex;\r\n}\r\n\r\n.ui.dropdown:not(.button) > .caption {\r\n  user-select: auto !important;\r\n  overflow: hidden;\r\n  max-width: 100%;\r\n}\r\n\r\ntd .ui.dropdown > .caption > .icon-caption {\r\n  display: contents;\r\n}\r\n\r\n\r\n.divided.list .item .description {\r\n  font-size: 90%;\r\n}\r\n\r\n/* Layout header start */\r\n\r\n.layout.header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n}\r\n\r\n.layout.header .ui.header {\r\n  max-width: 100%;\r\n  padding: 5px 5px;\r\n  display: inline-flex;\r\n}\r\n\r\n.layout.header.icon .ui.header .content {\r\n  /* \"overflow: hidden\" can't be used because of possible dropdowns */\r\n  width: 90%;\r\n  flex: 1 1;\r\n}\r\n\r\n.layout.header i.icons i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.layout.header > div {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n/* Layout header end */\r\n\r\n/* Dialogs start */\r\n\r\n.ui.modal.full .layout.header .content {\r\n  /* https://github.com/airdcpp-web/airdcpp-webclient/issues/324 */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.ui.modal.full table {\r\n  table-layout: fixed;\r\n}\r\n\r\n/* Can't be applied to dropdown cells */\r\n.ui.modal.full td:not(.dropdown) {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.ui.modal.full > .content {\r\n  min-height: 350px;\r\n  height: 65vh;\r\n}\r\n\r\n.ui.modal > .content {\r\n  overflow-y: auto;\r\n  max-height: 65vh;\r\n}\r\n\r\n.ui.modal {\r\n  /* Workaround for https://github.com/Semantic-Org/Semantic-UI/issues/6185 */\r\n  position: fixed !important;\r\n}\r\n\r\n/* Ensure that open modals are dimmed when a confirm dialog is displayed */\r\n.ui.dimmer.modals-node {\r\n  z-index: 1002;\r\n}\r\n\r\n.ui.dimmer.confirms-node {\r\n  z-index: 1003;\r\n}\r\n\r\n.ui.dimmer.confirms-node:not(:empty) {\r\n  opacity: 1;\r\n  display: block;\r\n}\r\n\r\n.confirm-dialog {\r\n  z-index: 1004 !important;\r\n}\r\n\r\n.confirm-dialog .description,\r\n.input.dialog {\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n}\r\n\r\n.input.dialog.basic,\r\n.confirm-dialog.basic label {\r\n  color: white !important;\r\n}\r\n\r\n.input.dialog input,\r\n.confirm-dialog label {\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.confirm-dialog .description {\r\n  width: 100% !important;\r\n}\r\n\r\n.limiter-config .remove {\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Dialogs end */\r\n\r\n/* Count label transitions */\r\n\r\n.label-transition-exit {\r\n  opacity: 1;\r\n}\r\n\r\n.label-transition-exit.label-transition-exit-active {\r\n  opacity: 0.01;\r\n  transition: opacity 1500ms ease-in;\r\n}\r\n\r\n/* Count label transitions end */\r\n\r\n/* Table dropdown transitions start */\r\n.mainmenu-transition-enter {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.mainmenu-transition-enter-active {\r\n  transform: translateX(0);\r\n  transition: transform 200ms ease-in-out;\r\n}\r\n\r\n.mainmenu-transition-exit {\r\n  display: none !important;\r\n}\r\n\r\n.mainmenu-transition-exit-active {\r\n  display: none !important;\r\n}\r\n\r\n.submenu-transition-enter {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.submenu-transition-enter-active {\r\n  transform: translateX(0%);\r\n  transition: transform 200ms ease-in-out;\r\n}\r\n\r\n.submenu-transition-exit {\r\n  display: none !important;\r\n}\r\n\r\n.submenu-transition-exit-active {\r\n  display: none !important;\r\n}\r\n\r\n/* Table dropdown transitions end */\r\n\r\n.sidebar .icon-panel .icon.large {\r\n  font-size: 1.3em;\r\n}\r\n\r\ntd:not(.dropdown),\r\nth {\r\n  overflow: hidden;\r\n}\r\n\r\n.notifications-tl h4.notification-title {\r\n  overflow: hidden;\r\n}\r\n\r\n.icon-caption > i {\r\n  margin-right: 5px;\r\n}\r\n\r\ni.icons .icon:first-child {\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n.dupe.queue.full,\r\n.dupe.queue.full span,\r\n.dupe.queue.full a {\r\n  color: #ffa500 !important;\r\n}\r\n\r\n.dupe.queue.partial,\r\n.dupe.queue.partial span,\r\n.dupe.queue.partial a {\r\n  color: #ffca68 !important;\r\n}\r\n\r\n.dupe.share.full,\r\n.dupe.share.full span,\r\n.dupe.share.full a {\r\n  color: fuchsia !important;\r\n}\r\n\r\n.dupe.share.partial,\r\n.dupe.share.partial span,\r\n.dupe.share.partial a {\r\n  color: #ffa2ff !important;\r\n}\r\n\r\n.dupe.finished.full,\r\n.dupe.finished.full span,\r\n.dupe.finished.full a {\r\n  color: green !important;\r\n}\r\n\r\n.dupe.finished.partial,\r\n.dupe.finished.partial span,\r\n.dupe.finished.partial a {\r\n  color: #79ff79 !important;\r\n}\r\n\r\n.dupe.finished.share,\r\n.dupe.finished.share span,\r\n.dupe.finished.share a {\r\n  color: color-mix(in lab, green, fuchsia) !important;\r\n}\r\n\r\n.dupe.finished.queue,\r\n.dupe.finished.queue span,\r\n.dupe.finished.queue a {\r\n  color: color-mix(in lab, green, #ffa500) !important;\r\n}\r\n\r\n.dupe.share.queue.finished,\r\n.dupe.share.queue.finished span,\r\n.dupe.share.queue.finished a,\r\n.dupe.share.queue,\r\n.dupe.share.queue span,\r\n.dupe.share.queue a {\r\n  color: color-mix(in lab, fuchsia, #ffa500) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
